var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 190.7 341.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ec1b32;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #213f7b;\n      }\n\n      .cls-4 {\n        fill: #21407b;\n      }\n\n      .cls-5 {\n        fill: #00aeaa;\n      }\n\n      .cls-6 {\n        fill: #fff6b1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.91,115.96c-.77,0-1.5-.45-1.82-1.2L47.09,19.6c-.43-1.01.03-2.17,1.04-2.61,1.01-.43,2.17.03,2.61,1.04l41,95.16c.43,1.01-.03,2.17-1.04,2.61-.26.11-.53.16-.79.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.91,115.96c-.26,0-.53-.05-.78-.16-1.01-.43-1.47-1.6-1.04-2.61l41-95.16c.43-1.01,1.6-1.47,2.61-1.04,1.01.43,1.47,1.6,1.04,2.61l-41,95.16c-.33.75-1.07,1.2-1.83,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.9,115.96c-.92,0-1.75-.65-1.94-1.58L64.9,2.38c-.22-1.07.47-2.12,1.54-2.34s2.12.47,2.34,1.54l23.07,111.99c.22,1.07-.47,2.12-1.54,2.34-.14.04-.27.05-.41.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.91,115.96c-.13,0-.27,0-.4-.04-1.07-.22-1.76-1.27-1.54-2.34L111.04,1.59c.22-1.07,1.27-1.76,2.34-1.54s1.76,1.27,1.54,2.34l-23.07,111.99c-.19.93-1.02,1.58-1.94,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.88,279.34L100.71,111.71c-.05-.12-.11-.23-.16-.35l-26.45-56.73c-.3-.64-.66-1.23-1.06-1.77-7.49-13.55-24.36-19.2-38.6-12.56-7.2,3.36-12.67,9.32-15.38,16.79-2.72,7.47-2.37,15.55.99,22.75s9.32,12.67,16.79,15.38c3.32,1.21,6.76,1.81,10.19,1.81,4.29,0,8.56-.94,12.56-2.8,3.16-1.47,5.98-3.44,8.38-5.82l13.56,29.07c-1.24,14.51,8.39,122.7,8.39,122.7,12.31,0,16.97,6.08,22.28,22.28s13.88,79.37,13.88,79.37h43.82c1.15,0,2.32-.2,3.44-.62,3.89-1.44,6.47-5.15,6.47-9.3v-48.38c0-1.45-.32-2.88-.93-4.19ZM47,86.13c-10.42,0-18.86-8.44-18.86-18.86s8.44-18.86,18.86-18.86,18.86,8.44,18.86,18.86-8.44,18.86-18.86,18.86Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.53,109.76l-17.6-8.4-.63,1.36,8.26,51.74,6.01-12.58c.69-11.75,1.04-20.86.74-24.4l3.32-7.12-.1-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.87,54.33c-.04.07-.07.15-.11.22l.1.12c.04-.09.09-.19.13-.28l-.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.61,156.63c.01-.13.02-.26.03-.4l-.25.52.22-.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.34 272.22 0 292.53 0 304.81 6.85 308.08 22.52 299.07 35.34 272.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20.94 314.8 27.35 301.38 30.2 319.22 48.72 328.06 40.17 274.53 20.94 314.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "26.33 224.88 41.45 215.99 51.67 194.57 48.96 176.36 26.33 224.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80,234.39l1.1,7.34c2.45-1.07,5.32-1.56,8.81-1.56,0,0,1.06-11.95,2.44-28.45l-2.12,1.25-10.23,21.42Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M55.15,236.85l-39.61,22.76,6.48-25.51-18.94,40.62,45.32-23.74,10.8,53.98c1.34-8.35,2.8-16.95,4.23-24.44l-1.08,1.44-7.2-45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M72.74,125.36l-21.13,45.32,17.71-23.68,7.21,45.11,18.26-10.49c.26-3.36.52-6.73.77-10.07l-12.28,6.43-10.54-52.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M105.31,78.6l-8.8-4.2-.47,1,5.49,34.37.09.59.21-.45,10.03-21.5c-2.8-2.77-5.02-6.09-6.55-9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M6.85,308.08l-6.85,3.93v19.9c0,2.88,1.25,5.55,3.31,7.39l19.2-40.23-15.66,9.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M27.35,301.38l-6.41,13.42-12.82,26.85h.03c.59.12,1.18.17,1.77.17h23.89l-3.61-22.6-2.85-17.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "58.43 205.8 54.38 188.89 51.67 194.57 41.45 215.99 38.74 221.66 54.43 214.18 58.43 205.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M73.24,223.16l4.05,16.9,2.71-5.67,10.23-21.42,2.44-5.12c.01-.15.02-.3.04-.44l-15.47,7.37-4,8.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "0 304.81 0 312.01 6.85 308.08 0 304.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.78,52.86c-.34.45-.65.95-.91,1.47l.13.06c.24-.52.51-1.03.78-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.29,102.72l-4.03,8.64c-.06.11-.11.23-.16.35l-6.37,13.65,10.53,52.61,12.28-6.43c.38-5.07.74-10.09,1.07-14.91l-.22.13.25-.52c.35-5.06.66-9.9.92-14.36l-6.01,12.58-8.26-51.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M104.85,77.44c-2.72-7.47-2.37-15.55.99-22.75,0,0,.01-.02.01-.03l-.1-.12s-.03.06-.04.08l-9.22,19.76,8.8,4.2c-.14-.37-.29-.75-.44-1.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "96.04 75.39 83.93 101.36 101.53 109.76 96.04 75.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M3.08,274.73l-2.15,4.61c-.61,1.31-.93,2.74-.93,4.19v9l35.33-20.31-12.82,26.85h0l-19.2,40.23c.91.81,1.97,1.47,3.16,1.91.55.2,1.11.36,1.67.46h-.03s12.82-26.86,12.82-26.86h0l19.23-40.27,8.55,53.54-18.52-8.84,3.61,22.6h19.93s2.41-17.76,5.47-36.86l-10.8-53.98-45.32,23.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "58.43 205.8 54.43 214.18 50.89 221.6 65.84 214.48 61.98 198.37 58.43 205.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "65.84 214.48 69.69 230.58 73.24 223.16 77.24 214.78 80.79 207.35 65.84 214.48"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186.4,33.58c-11.33-5.29-23.04-3.37-32.97,5.39-1.39,1.23-2.65,2.51-3.78,3.76-1.34-.91-2.76-1.73-4.26-2.43-14.24-6.64-31.11-1-38.6,12.56-.28.5-.54,1.01-.79,1.53-.04.09-.09.19-.13.28,0,0-.01.02-.01.03-3.36,7.2-3.71,15.28-.99,22.75.14.39.3.77.45,1.16,1.53,3.72,3.75,7.04,6.55,9.81,2.4,2.38,5.23,4.35,8.38,5.83,4,1.87,8.27,2.8,12.56,2.8,3.43,0,6.87-.6,10.19-1.81,7.47-2.72,13.43-8.18,16.79-15.38,3.36-7.2,3.71-15.28.99-22.75-.37-1.02-.8-2.02-1.27-2.98,1.12-1.39,2.47-2.87,4.03-4.21,3.42-2.94,8.87-6.44,16.59-2.84,3.72,1.74,8.15.13,9.88-3.6,1.72-3.74.11-8.17-3.61-9.9ZM132.81,86.13c-6.66,0-12.5-3.45-15.86-8.66-1.9-2.94-3-6.44-3-10.2,0-.98.07-1.94.22-2.87.29-1.88.85-3.66,1.65-5.31.67-1.38,1.49-2.66,2.46-3.83,1.04-1.25,2.24-2.37,3.56-3.32,3.09-2.22,6.88-3.53,10.97-3.53,10.42,0,18.86,8.44,18.86,18.86s-8.44,18.86-18.86,18.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.18,311c1.33-.98,1.94-2.74,1.39-4.39-.68-2.06-2.9-3.19-4.97-2.51-2.06.68-3.19,2.9-2.51,4.97.29.87-.12,2.07-1.64,2.57-1.52.5-2.34-.29-2.63-1.16-.52-1.57-2.01-2.69-3.75-2.69-2.17.01-3.93,1.78-3.92,3.95.01,2.17,1.78,3.93,3.95,3.92.91,0,1.93.75,1.93,2.36s-1,2.14-1.92,2.14c-1.65.02-3.18,1.08-3.71,2.74-.66,2.07.48,4.29,2.55,4.95s4.29-.48,4.95-2.55c.28-.87,1.31-1.6,2.84-1.11,1.53.49,1.72,1.61,1.44,2.48-.5,1.58.04,3.36,1.45,4.38,1.76,1.27,4.22.87,5.49-.89s.87-4.22-.89-5.49c-.74-.53-1.12-1.74-.18-3.04.94-1.3,2.07-1.14,2.81-.6,1.34.96,3.21.99,4.61-.04,1.75-1.28,2.13-3.75.85-5.5s-3.75-2.13-5.5-.85c-.74.54-2,.52-2.95-.77-.93-1.3-.43-2.32.31-2.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.47,204.28c-1.33.98-1.94,2.74-1.39,4.39.68,2.06,2.9,3.19,4.97,2.51,2.06-.68,3.19-2.9,2.51-4.97-.29-.87.12-2.07,1.64-2.57s2.34.29,2.63,1.16c.52,1.57,2.01,2.69,3.75,2.69,2.17-.01,3.93-1.78,3.92-3.95s-1.78-3.93-3.95-3.92c-.91,0-1.93-.75-1.93-2.36-.01-1.6,1-2.14,1.92-2.14,1.65-.02,3.18-1.08,3.71-2.74.66-2.07-.48-4.29-2.55-4.95-2.07-.66-4.29.48-4.95,2.55-.28.87-1.31,1.6-2.84,1.11-1.53-.49-1.72-1.61-1.44-2.48.5-1.58-.04-3.36-1.45-4.38-1.76-1.27-4.22-.87-5.49.89s-.87,4.22.89,5.49c.74.53,1.12,1.74.18,3.04-.94,1.3-2.07,1.14-2.81.6-1.34-.96-3.21-.99-4.61.04-1.75,1.28-2.13,3.75-.85,5.5s3.75,2.13,5.5.85c.74-.54,2-.52,2.95.77.93,1.31.43,2.33-.31,2.87Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 116.01,
    cy: 197.42,
    r: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M119.16,203.46s4.19,12.72,4.48,13.6c.29.87,1.05.18,1.36-.45.32-.63-.04-8.26,8.53-11.09,2.77-.91,2.99,17-2.77,18.9-1.71.56-1.94-.33-3.17.08-1.15.38-1.26,1.38-2.14,1.67-.87.29-1.56-.45-2.71-.07-1.23.4-.89,1.26-2.59,1.82-5.76,1.9-16.22-12.64-13.45-13.55,8.57-2.82,12.82,3.53,13.45,3.85s1.65.42,1.36-.45c-.29-.87-4.48-13.6-4.48-13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.77,231.26l-19.17,6.31c-.36.12-.75-.08-.87-.44l-1.79-5.44c-.12-.36.08-.75.44-.87l19.17-6.31c.36-.12.75.08.87.44l1.79,5.44c.12.35-.08.75-.44.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.23,253.17l-4.94,1.63c-.19.06-.4-.04-.46-.23l-2-6.07c-.06-.19.04-.4.23-.46l4.94-1.63c.19-.06.4.04.46.23l2,6.07c.07.19-.04.39-.23.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.92,255.57l-12.21,4.02c-.29.1-.61-.06-.7-.35l-1.88-5.7c-.1-.29.06-.61.35-.7l12.21-4.02c.29-.1.61.06.7.35l1.88,5.7c.1.29-.06.61-.35.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.26,232.75c.36-.12.72-.01.87.44s-.04,8.26-.04,8.26c0,0,.07.71-.94,1.04l-13.19,4.34c-1.01.33-1.37-.28-1.37-.28,0,0-4.79-6.16-4.94-6.62-.15-.45.08-.75.44-.87l19.17-6.31Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 155.64,
    cy: 317.87,
    r: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.49,311.83s-4.19-12.72-4.48-13.6c-.29-.87-1.05-.18-1.36.45-.32.63.04,8.26-8.53,11.09-2.77.91-2.99-17,2.77-18.9,1.71-.56,1.94.33,3.17-.08,1.15-.38,1.26-1.38,2.14-1.67.87-.29,1.56.45,2.71.07,1.23-.4.89-1.26,2.59-1.82,5.76-1.9,16.22,12.64,13.45,13.55-8.57,2.82-12.82-3.53-13.45-3.85s-1.65-.42-1.36.45c.29.87,4.48,13.6,4.48,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.88,284.03l19.17-6.31c.36-.12.75.08.87.44l1.79,5.44c.12.36-.08.75-.44.87l-19.17,6.31c-.36.12-.75-.08-.87-.44l-1.79-5.44c-.12-.36.08-.75.44-.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.42,262.12l4.94-1.63c.19-.06.4.04.46.23l2,6.07c.06.19-.04.4-.23.46l-4.94,1.63c-.19.06-.4-.04-.46-.23l-2-6.07c-.07-.19.04-.39.23-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.73,259.72l12.21-4.02c.29-.1.61.06.7.35l1.88,5.7c.1.29-.06.61-.35.7l-12.21,4.02c-.29.1-.61-.06-.7-.35l-1.88-5.7c-.1-.29.06-.61.35-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M133.39,282.54c-.36.12-.72.01-.87-.44s.04-8.26.04-8.26c0,0-.07-.71.94-1.04l13.19-4.34c1.01-.33,1.37.28,1.37.28,0,0,4.79,6.16,4.94,6.62.15.45-.08.75-.44.87l-19.17,6.31Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 89.91,
    cy: 113.98,
    r: 4.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.43,214.18l-15.69,7.48,2.71-5.67-15.12,8.9-4.3,9.22-6.48,25.51,39.61-22.76,7.21,45.11,1.08-1.44c1.47-7.7,2.92-14.22,4.19-18.07,3.8-11.61,7.28-18.02,13.47-20.72l-1.1-7.34-2.71,5.67-4.05-16.9-3.54,7.42-3.86-16.11-14.95,7.13,3.53-7.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.52,192.1l-7.21-45.11-17.71,23.68-2.65,5.68,2.72,18.21,2.71-5.67,4.05,16.9,3.54-7.42,3.86,16.11,14.95-7.13-3.54,7.42,15.46-7.37c.66-8,1.38-16.85,2.07-25.79l-18.25,10.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.35,211.72c.11-1.27.21-2.56.32-3.87l-2.44,5.12,2.12-1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.954ce3d2adcbee260c87cc9846e2db44.svg";
export { ForwardRef as ReactComponent };